import { ChangeDetectorRef, Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';
import { RoutingHistoryService } from 'src/app/shared/services/routing-history.service';

@Component({
  selector: 'fgb-lotto-wallet-details-page',
  templateUrl: './lotto-wallet-details-page.component.html',
  styleUrls: ['./lotto-wallet-details-page.component.scss'],
})
export class LottoWalletDetailsPageComponent implements OnInit, AfterViewInit {
  @Input() id: number;
  mobileTitle: string = '';
  constructor(
    private location: Location,
    private rewardWalletService: RewardsWalletService,
    private cd: ChangeDetectorRef,
    private routeHistory: RoutingHistoryService
  ) {}

  ngOnInit() {
    firstValueFrom(this.rewardWalletService.fetchWalletItems());
  }
  ngAfterViewInit(): void {
    this._getMobileTitle(this.routeHistory.getPreviousUrl() || '');
  }

  private _getMobileTitle(url: string): void {
    this.mobileTitle = url?.toLowerCase().includes('claimed') ? 'wallet.redeemed.title' : 'wallet.page.title';
    this.cd.detectChanges();
  }
  back(): void {
    this.location.back();
  }
}
